import App from './App.vue';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createHead } from '@unhead/vue';
import FloatingVue from 'floating-vue';
import InstantSearch from 'vue-instantsearch/vue3/es';
import VueDatePicker from '@vuepic/vue-datepicker';
import VCalendar from 'v-calendar';
import JsonViewer from 'vue-json-viewer';
import vueCountryRegionSelect from "vue-country-region-select";
import {auth0} from '@/services/auth0';
import router from "./router";
// import NotificationCenterPlugin from '@novu/notification-center-vue';

// import '@novu/notification-center-vue/dist/style.css';
import '../node_modules/flowbite-vue/dist/index.css'


import vPermission from "./utils/directives/v-permission"
import vLegalStep from "./utils/directives/v-step"

import setupSentry from "@/services/sentry";

const app = createApp(App)
  .use(router)
  .use(createPinia())
  .use(InstantSearch)
  .use(FloatingVue)
  .use(auth0 as any)
  .use(VCalendar)
  .use(JsonViewer)
  .use(vueCountryRegionSelect)
  // .use(NotificationCenterPlugin)
  .use(createHead())

// Create a global head instance
setupSentry(app);

app.component('VueDatePicker', VueDatePicker);

app.directive('permission', vPermission);
app.directive('can', vPermission);
app.directive('step', vLegalStep);

app.mount('#app');
